/**
 * API Configuration
 * 
 * This file contains all API-related configuration settings.
 * Environment-specific values are loaded from .env files.
 */

// Base API URL (server/port)
//export const API_BASE_URL = 'https://backend-375590532335.us-central1.run.app';
export const API_BASE_URL = 'https://api.scos.ai';
//export const API_BASE_URL = 'http://localhost:8000';

// API Version
export const API_VERSION =  'v1';

// Full API Base Pathß
export const API_PATH = `${API_BASE_URL}/api/${API_VERSION}`;

// Timeout for API requests (in milliseconds)
export const API_TIMEOUT = 30000;

// Whether to include credentials in API requests
export const API_INCLUDE_CREDENTIALS = true;

// API Key for the Supply Chain Frontend
export const API_KEY = '5229dff0-c15e-4447-85e6-1983cc975903';  // Make sure this is set

// Google Client ID - following same pattern as API_KEY
export const GOOGLE_CLIENT_ID = '375590532335-82c9hej8ndc3cbdo3lljlbel52f8er6u.apps.googleusercontent.com';

// Invoice Processing API Configuration (separate from main SCOS API)
export const INVOICE_API_BASE_URL = 'https://invoices.scos.ai';
export const INVOICE_API_VERSION = 'v1';
export const INVOICE_API_PATH = `${INVOICE_API_BASE_URL}/api/${INVOICE_API_VERSION}`;
export const INVOICE_API_KEY = 'f33389dd-dad4-4621-825c-5c0dbd61c2c5';
export const INVOICE_API_TIMEOUT = 30000;

// Add API key to default headers
export const DEFAULT_HEADERS = {
    'Content-Type': 'application/json',
    'X-API-Key': API_KEY
};

// Update axios config with CORS settings
export const axiosConfig = {
    baseURL: API_PATH,
    timeout: API_TIMEOUT,
    headers: {
        ...DEFAULT_HEADERS,
        'Content-Type': 'application/json',
    },
    withCredentials: true,  // Important for CORS with credentials
    maxRedirects: 0  // Prevent redirects
};

// Public endpoints that don't need tenant context
export const PUBLIC_ENDPOINTS = [
    '/health',
    '/api/v1/auth/token',
    '/api/v1/license/validate',
    '/api/v1/license/activate',
    '/api/v1/license/deactivate',
    '/api/v1/license/info',
    '/api/v1/admin/domains/resolve-public',
    '/api/v1/admin/domains/resolve-public/'
];